import * as React from 'react';
import { Box, Flex } from '../CommonUI/Layout';
import { Label } from '../CommonUI';
import Button from '../CommonUI/Control/Button';
import { Text } from 'ilenia';
import { css, StyleSheet } from 'aphrodite';

interface SettingsRestoreProps {
    onRestoreSettings: (restore: boolean) => void;
}

interface SettingsRestoreState {
    foo?: string;
}

export class SettingsRestore extends React.Component<SettingsRestoreProps, SettingsRestoreState> {
    constructor(props: SettingsRestoreProps) {
        super(props);
        this.state = {  };
        this.onClick = this.onClick.bind(this);
    }

    public onClick(restore: boolean) {
        return () => {
            this.props.onRestoreSettings(restore);
        };
    }

    public render() {
        return (
            <Box pb={30}>
                <Flex alignItems={'left'} flexDirection={'column'}>
                    <Box ml={2} mb={10} className={css(styles.text)}>
                        <Label label="settingsRestore.title" />
                        <Text id="settingsRestore.text" />
                    </Box>
                    <Box mt={0}>
                        <Flex flexDirection={'row'}>
                            <Button
                                width={'unset'}
                                pl={2}
                                pr={12}
                                onClick={this.onClick(true)}
                            >
                                <Text id="settingsRestore.buttonAction"/>
                            </Button>
                            <Button
                                secondaryButton={true}
                                width={'unset'}
                                pl={12}
                                onClick={this.onClick(false)}
                            >
                                <Text id="settingsRestore.buttonCancel"/>
                            </Button>
                        </Flex>
                    </Box>
                </Flex>
            </Box>
        );
    }
}

const styles = StyleSheet.create({
    text: {
        lineHeight: '1.43',
        maxWidth: '514px',
    }
});



// WEBPACK FOOTER //
// ./src/Containers/SettingsRestore.tsx